<template>
  <div :class="$style.wrapper">
      <div :class="$style.left" ref="left">
        <Transition name="fade-top">
          <template v-if="stage > -1">
            <img v-if="!animation" :src="image">
          </template>
        </Transition>
      </div>
    <Transition name="fade-right-bottom">
      <div :class="$style.right">
        <HintContainer
          v-if="stage === 0"
          :className="$style.hints"
          :innerClassName="$style.hintsInner"
        >
          <div>
            <Hint
              v-for="(item, index) in about"
              :key="index"
            >
              <h2>{{item.title}}</h2>
              <p>{{item.text}}</p>
            </Hint>
          </div>
          <Button
            :wide="true"
            :className="$style.hintButton"
            @click="() => { this.stage++ }"
          >
            Любопытно
          </Button>
        </HintContainer>
        <Transition name="fade-right">
          <HintContainer
            v-if="stage === 1"
            :className="$style.hints"
            :innerClassName="$style.hintsInner"
          >
            <Hint>
              <h2>{{question}}</h2>
              <div :class="$style.radio">
                <Radio
                  v-for="(item, index) in answers"
                  :key="index"
                  :label="item.text"
                  :value="`${item.id}`"
                  :name="'answer'"
                  v-model="answer"
                  :disabled="answer !== null"
                  :theme="radioTheme"
                />
                <Button
                  v-if="answer !== null"
                  :className="$style.button"
                  :wide="true"
                  @click="handleButton"
                >
                  {{ buttonText }}
                </Button>
              </div>
            </Hint>
          </HintContainer>
        </Transition>
        <img src="./assets/char.svg" :class="$style.char">
      </div>
    </Transition>
  </div>
</template>
<script>
import lottie from 'lottie-web'
import HintContainer from '@/components/@ui/HintContainer/HintContainer.vue'
import Hint from '@/components/@ui/Hint/Hint.vue'
import Button from '@/components/@ui/Button/Button.vue'
import Radio from '@/components/@ui/Radio/Radio.vue'

export default {
  name: 'PopupWithQuestions',
  components: {
    Hint, HintContainer, Button, Radio,
  },
  props: {
    question: String,
    text: String,
    answers: Array,
    image: String,
    about: Array,
    animation: Object,
  },
  data() {
    return {
      stage: -1,
      answer: null,
      isCorrect: undefined,
      retryCount: 0,
    }
  },
  mounted() {
    this.stage = 0

    if (!this.animation) return

    lottie.loadAnimation({
      container: this.$refs.left,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: this.animation,
    })
  },
  computed: {
    radioTheme() {
      const { isCorrect } = this
      if (isCorrect === true) return 'green'
      if (isCorrect === false) return 'red'
      return ''
    },
    buttonText() {
      const { isCorrect, retryCount } = this
      if (!isCorrect && retryCount < 1) return 'Попробовать еще раз'
      return 'Продолжить исследование'
    },
  },
  watch: {
    answer() {
      const { answer, answers } = this
      const correctAnswer = `${answers.find(i => i.isCorrect).id}`
      this.isCorrect = correctAnswer === answer
    },
  },
  methods: {
    handleButton() {
      const { retryCount, isCorrect } = this

      if (isCorrect) return this.$emit('success')

      if (retryCount < 1) {
        this.isCorrect = undefined
        this.answer = null
        this.retryCount += 1
        return false
      }

      return this.$emit('fail')
    },
  },
}
</script>
<style lang="scss" module>
@import './PopupWithQuestions.scss';
</style>
